import { render, staticRenderFns } from "./PackPriceList.vue?vue&type=template&id=3f715c80&"
import script from "./PackPriceList.vue?vue&type=script&lang=js&"
export * from "./PackPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports